import comp from "./MaxScore";
export default comp;
